import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import rateIcon from "../../assets/images/projectManagement/rate.svg";
import trashIcon from "../../assets/images/projectManagement/trash-2.svg";
import { LimitEmployeeSelect } from "../../utils/globalVariable";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
// import { ChevronDownIcon } from "@chakra-ui/icons";

export const FormBonus = ({
  id,
  filteredOptions,
  selectedMain,
  titleRate,
  nameMain,
  deleteData,
  onChangeName,
  onChangeBonus,
  onChangeJobTitle,
  jobTitleMain,
  isFocused,
  onFocus,
  onBlur,
  required,

  //
  isAddDate,
  onChangeStartDate,
  onChangeEndDate,
  selectedStartDate,
  selectedEndDate,
  //
  isError,
  isErrorItem,
}) => {
  const [dataSelect, setDataSelect] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [zIndex, setZIndex] = useState("");
  // const [dataJobTitle, setDataJobTitle] = useState("");

  const onChangeActionName = (value) => {
    setZIndex("name");
    onChangeName(value);
  };

  const onChangeActionBonus = (value) => {
    setZIndex("bonus");
    onChangeBonus(value.target.value);
  };

  const onChangeActionJobTitle = (value) => {
    onChangeJobTitle(value.target.value);
  };

  useEffect(() => {
    if (
      selectedMain !== undefined &&
      selectedMain !== null &&
      selectedMain !== ""
    ) {
      setDataSelect(selectedMain);
    }

    // if (nameMain) {
    //   setDataBonus(nameMain);
    // }

    // if (jobTitleMain) {
    //   setDataJobTitle(jobTitleMain);
    // }
  }, [selectedMain]);

  const check = filteredOptions.find((option) => option.value === dataSelect);

  const filteredResults = filteredOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box
      borderBottom={"1px solid var(--border-input-employee)"}
      paddingBottom={"20px"}
      marginBottom={"10px"}
       w={"100%"}
    >
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        w={"100%"}
      >
        <Box
          w={"100%"}
          borderRadius={"12px"}
          maxW={"100%"}
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          h={"auto"}
          // zIndex={isFocused ? 4 : 1}
          zIndex={isFocused && zIndex === "name" ? 3 : 1}
        >
          <Flex gap={"4px"} alignItems={"center"} w={"100%"}> 
            <Text
              fontSize={{ base: "12px" }}
              fontWeight={400}
              lineHeight={"15px"}
              color={"var(--color-label-employee)"}
            >
              Tên người quản lý
            </Text>
            {required && (
              <Text
                fontSize={{ base: "12px" }}
                color={"red"}
                lineHeight={"15px"}
              >
                *
              </Text>
            )}
          </Flex>

          <Menu matchWidth>
            <MenuButton
              _active={{
                border: "1px solid var(--color-option-employee-hover)",
                borderBottom: "1px solid var(--color-option-employee-hover)",
              }}
              _hover={{
                boxShadow: "none",
              }}
              type={"button"}
              // rightIcon={<ChevronDownIcon color="#000" />}
              w="100%"
              backgroundColor="#FFF"
              border={"1px solid var(--bg-line-employee)"}
              fontSize="14px"
              fontWeight={500}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              textAlign={"left"}
              p={"0"}
              h={"auto"}
              maxH={"44px"}
              padding={"13px 12px 14px 12px"}
              color={
                dataSelect !== undefined &&
                dataSelect !== null &&
                dataSelect !== ""
                  ? "var(--color-info-employee)"
                  : "var(--color-placeHolder-employee)"
              }
              borderRadius={"8px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
              onFocus={onFocus}
              onBlur={onBlur}
              onClick={() => setZIndex("name")}
            >
              {dataSelect !== undefined &&
              dataSelect !== null &&
              dataSelect !== "" &&
              check
                ? check.label
                : "Tên nhân viên dự án"}
            </MenuButton>

            <MenuList
              borderRadius="12px"
              minW="275px"
              overflow={"scroll"}
              maxH={"250px"}
              zIndex={4}
            >
              <Input
                placeholder="Tìm kiếm..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                mb="8px"
                p="8px"
                border="1px solid var(--bg-line-employee)"
                borderRadius="8px"
                width="90%"
                mx="auto"
                display="block"
              />
              {filteredResults.length > 0 ? (
                filteredResults.map((option, index) => {
                  if (index < LimitEmployeeSelect) {
                    return (
                      <MenuItem
                        key={option.value}
                        onClick={() => onChangeActionName(option.value)}
                        backgroundColor={"#FFF"}
                        color={"#000"}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  }
                })
              ) : (
                <Box fontSize="14px" p="12px" textAlign="center">
                  Không tìm thấy kết quả
                </Box>
              )}
            </MenuList>
          </Menu>
        </Box>
        <FormControl
          display={"flex"}
          flexDirection={"column"}
          gap={{ base: "6px" }}
          maxW={"100%"}
        >
          <Flex gap={"4px"} alignItems={"center"} w={"100%"}>
            <FormLabel
              fontSize={"12px"}
              fontWeight={400}
              color="var(--text-color-Subtittle)"
              lineHeight={"15px"}
              m={{ base: "0" }}
            >
              {titleRate || "Hệ số thưởng"}
            </FormLabel>
            {required && (
              <Text
                fontSize={{ base: "12px" }}
                color={"red"}
                lineHeight={"15px"}
              >
                *
              </Text>
            )}
          </Flex>

          <Flex
            justifyContent={"space-between"}
            gap={"32px"}
            alignItems={"center"}
          >
            <InputGroup
              mt={"0"}
              p={{ base: "10px 14px 10px 12px" }}
              alignItems={"center"}
              h={"44px"}
              border={"0.5px solid var(--Line)"}
              borderRadius={"8px"}
              _focus={{
                boxShadow: "none",
              }}
              zIndex={isFocused && zIndex === "bonus" ? 3 : 1}
            >
              <Input
                type="number"
                color="var(--text-color-Subtittle)"
                fontWeight={500}
                fontSize={"14px"}
                border={"none"}
                p={"0px"}
                placeholder={onChangeJobTitle ? "0.0" : "Nhập hệ số thưởng"}
                // type={"text"}
                _focus={{
                  boxShadow: "none",
                }}
                min={0}
                max={100}
                borderRight={"1px solid #DAE0EB"}
                borderRadius={"0"}
                h={"24px"}
                value={nameMain || ""}
                onChange={(e) => onChangeActionBonus(e)}
                step="any"
              />
              <Image src={rateIcon} ml={"16px"} />
            </InputGroup>
            <Image
              cursor={"pointer"}
              src={trashIcon}
              mr={"12px"}
              w={"22px"}
              h={"22px"}
              minH={"22px"}
              minW={"22px"}
              onClick={deleteData}
              _hover={{
                filter: "var(--filter-red)",
              }}
            />
          </Flex>
        </FormControl>
      </Flex>
      {onChangeJobTitle && (
        <FormControl
          display={"flex"}
          flexDirection={"column"}
          gap={{ base: "6px" }}
          maxW={"100%"}
        >
          <FormLabel
            fontSize={"12px"}
            fontWeight={400}
            color="var(--text-color-Subtittle)"
            lineHeight={"15px"}
            m={{ base: "0" }}
            mt={"12px"}
          >
            Chức danh
          </FormLabel>
          <Flex
            justifyContent={"space-between"}
            gap={"32px"}
            alignItems={"center"}
          >
            <InputGroup
              mt={"0"}
              p={{ base: "10px 14px 10px 12px" }}
              alignItems={"center"}
              h={"44px"}
              border={"0.5px solid var(--Line)"}
              borderRadius={"8px"}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Input
                color="var(--text-color-Subtittle)"
                fontWeight={500}
                fontSize={"14px"}
                border={"none"}
                p={"0px"}
                placeholder={"Nhập chức danh"}
                // type={"text"}
                _focus={{
                  boxShadow: "none",
                }}
                borderRadius={"0"}
                h={"24px"}
                value={jobTitleMain || ""}
                onChange={(e) => onChangeActionJobTitle(e)}
                step="any"
              />
            </InputGroup>
          </Flex>
        </FormControl>
      )}
      {isAddDate && (
        <Flex
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          gap={"27px"}
          w={"100%"}
          mt={"12px"}
        >
          <FormControl
            flex={1}
            zIndex={isFocused && zIndex === "startDate" ? 3 : 1}
          >
            <FormLabel
              mb={"6px"}
              fontSize={{ base: "12px" }}
              fontWeight={400}
              color={"var(--color-label-employee)"}
              display={"flex"}
              gap={"4px"}
            >
              TG bắt đầu tham gia DA
            </FormLabel>
            <InputGroup>
              <DatePicker
                width="100%"
                selected={selectedStartDate}
                onChange={(e) => {
                  onChangeStartDate(e);
                }}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                placeholderText="dd/mm/yy"
                className="custom-datepicker datePickerStyle"
                // onFocus={() => handleFocus("bookingTime", "bookingTime")}
                // onBlur={() => handleBlur("bookingTime")}
                onFocus={onFocus}
                onBlur={onBlur}
                onInputClick={() => setZIndex("startDate")}
              />
              <InputRightElement pointerEvents="none" h={"44px"}>
                <Image src={calendarIcon} />
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <FormControl
            flex={1}
            zIndex={isFocused && zIndex === "endDate" ? 3 : 1}
          >
            <FormLabel
              mb={"6px"}
              fontSize={{ base: "12px" }}
              fontWeight={400}
              color={"var(--color-label-employee)"}
              display={"flex"}
              gap={"4px"}
            >
              TG kết thúc tham gia DA
            </FormLabel>
            <InputGroup>
              <DatePicker
                width="100%"
                selected={selectedEndDate}
                onChange={(e) => {
                  setZIndex("endDate");
                  onChangeEndDate(e);
                }}
                onInputClick={() => setZIndex("endDate")}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                placeholderText="dd/mm/yy"
                className="custom-datepicker datePickerStyle"
                // onFocus={() => handleFocus("bookingTime", "bookingTime")}
                // onBlur={() => handleBlur("bookingTime")}
                onFocus={onFocus}
                onBlur={onBlur}
              />
              <InputRightElement pointerEvents="none" h={"44px"}>
                <Image src={calendarIcon} />
              </InputRightElement>
            </InputGroup>
          </FormControl>
        </Flex>
      )}

      {isErrorItem?.status && isErrorItem?.id === id && (
        <Text w={"100%"} color={"var(--text-red-employee)"} fontSize={"12px"}>
          Người quản lý đã tồn tại, vui lòng nhập người quản lý khác.
        </Text>
      )}
    </Box>
  );
};
